import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { I18n } from "aws-amplify/utils";
function ConfirmSuspendAlarmDialog({ open, onClose, onSave, onCancel }) {

  const handleSave = () => {
    onSave();
    onClose();
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle>{I18n.get("Operation confirmation")}</DialogTitle>
      <DialogContent>
        <p>{I18n.get("Are you sure you want to suspend the alarm with no expiration date?")}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          {I18n.get("Cancel")}
        </Button>
        <Button
          onClick={handleSave}
          color="error"
        >
          {I18n.get("Confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmSuspendAlarmDialog;
